module.exports = __webpack_public_path__ + "img/entertainment-area.d469dd6.png";